import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';


import dropdownTemplate from './dropdown-template.pug';

export class DropdownView extends Backbone.View {
  initialize({
    observable,
    field,
    i18n,
    isForVNext,
  }) {
    observable.validators.type.isValid = () => true; //eslint-disable-line
    this.viewModel = {
      observable,
    };
    this.field = field;
    this.i18n = i18n;
    this.isForVNext = isForVNext;
  }

  render() {
    this.$el.html(dropdownTemplate({
      hasStore: _.size(this.field.values) > 0,
      field: this.field,
      i18n: this.i18n,
      isForVNext: this.isForVNext,
    }));
    ko.applyBindings(this.viewModel, this.el);

    return this;
  }
}
